/** Official feeds use both CSS hex and RGB colors. Return an opaque, safe RGB color. */
export function normalizeLeagueColor(value: unknown): string {
  const color = typeof value === 'string' ? value.trim() : ''
  const hex = /^#([\da-f]{3}|[\da-f]{4}|[\da-f]{6}|[\da-f]{8})$/i.exec(color)
  let channels: number[] | undefined
  let alpha = 1
  if (hex) {
    const digits = hex[1].length <= 4 ? [...hex[1]].map(c => c + c).join('') : hex[1]
    channels = [0, 2, 4].map(i => parseInt(digits.slice(i, i + 2), 16))
    if (digits.length === 8) alpha = parseInt(digits.slice(6), 16) / 255
  } else {
    const rgb = /^rgba?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)(?:\s*,\s*(0|1|0?\.\d+))?\s*\)$/i.exec(color)
    if (rgb) {
      channels = rgb.slice(1, 4).map(Number)
      if (channels.some(channel => channel > 255)) channels = undefined
      alpha = rgb[4] === undefined ? 1 : Number(rgb[4])
    }
  }
  return channels ? `rgb(${channels.map(channel => Math.round(channel * alpha + 255 * (1 - alpha))).join(', ')})` : 'rgb(88, 112, 145)'
}

/** Mix a league color with white (0 = original, 1 = white). */
export function lightenRgb(color: unknown, lightness: number): string {
  const amount = Number.isFinite(lightness) ? Math.min(1, Math.max(0, lightness)) : 0.95
  const channels = normalizeLeagueColor(color).match(/\d+/g)!.map(Number)
  return `rgb(${channels.map(channel => Math.round(channel + (255 - channel) * amount)).join(', ')})`
}
